import { RoleId } from "@/entities/role";
import { Policy } from "@/policies";
const policyNamespace = "citizen";

export interface CitizenPolicyContext {
  userRoleId: unknown;
}

export function isCitizenPolicyContext(
  obj: unknown
): obj is CitizenPolicyContext {
  const tmp = obj as CitizenPolicyContext;

  return tmp.userRoleId !== undefined;
}

export const citizenPolicy: Policy = {
  async can(context: unknown) {
    if (!isCitizenPolicyContext(context)) {
      return false;
    }
    return context.userRoleId == RoleId.Citizen;
  },
};

const policyMap = new Map();
policyMap.set(`${policyNamespace}/view`, citizenPolicy);

export default policyMap;
